import { Outlet } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';

import { BusinessRole } from 'src/constants/user';
import { ApiIntegrationsPage, IntegrationUsageLogsPage } from 'src/pages';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <ApiIntegrationsPage />,
    accessRoles: [BusinessRole.PlatformAdmin, BusinessRole.PlatformManager],
  },
  {
    path: `:${RouterEntitiesId.integration}/usage-logs`,
    element: <IntegrationUsageLogsPage />,
    accessRoles: [BusinessRole.PlatformAdmin, BusinessRole.PlatformManager],
  },
];

export const API_INTEGRATIONS_ROUTE: RouteProps = {
  path: appRoutes.apiIntegrations.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [BusinessRole.PlatformAdmin, BusinessRole.PlatformManager],
};
